import React, { Component } from 'react'
import './pagination.css'
import { PaginationContext } from '../../context/pagination'


class Pagination extends Component {
  constructor(props, context) {
    super(props)
    this.state = {
      contextState: context.state,
      numPages: null,
      crumbs: null,
      path: context.path
    }
  }

  componentDidUpdate(prevProps, prevState) {
    let numPages = this.state.numPages
    if (prevState.path !== this.context.path || this.context.forcePaginationRender) {
      numPages = 0
      const pagination = this.context.state
      for(let i = 0; i < pagination.length; i++) {
        numPages += pagination[i].numPages
      }
      this.setState({ ...this.state,
        numPages,
        path: this.context.path,
        contextState: this.context.state
      })
    }
    for (let index in this.state.contextState) {
      if (this.state.contextState[index].path === this.context.path) {
        if (!this.state.contextState[index].activePage) {
          numPages = 0
        }
        break
      }
    }
    let crumbs = []
    const { state } = this.context
    let activePage = 0
    let active = false

    for(let i = state.length - 1; i >= 0 ; i --){
      if(active){
        activePage += state[i].numPages
      }
      if(state[i].activePage > 0 && !active){
        activePage += state[i].activePage
        active = true
      }
    }

    let circleColor = "navigation-circle"
    if (this.state.path === '/profile') {
      circleColor += " navigation-circle__green"
    } else {
      circleColor += " navigation-circle__blue"
    }

    for(let i = 0; i < numPages; i++){
      i < activePage ? crumbs.push(
        <div key={`circle${i}`} className={circleColor}></div>
      ) :
      crumbs.push(
        <div key={`circle${i}`} className="navigation-circle"></div>
      ) 
    }
    
    for (let i = 0; i < prevState.contextState.length; i++) {
      if (prevState.contextState[i].path !== this.context.state[i].path || prevState.contextState[i].activePage !== this.context.state[i].activePage || this.context.forcePaginationRender) {
        this.setState({
          crumbs,
          contextState: this.context.state
        })
        break
      }
    }
  }

  render() {
    let { crumbs } = this.state
    return (
      <div className="navigation-bar">
        <div className="navigation">
          <div className="line"></div>
          {crumbs}
        </div>
      </div>
    )
  }
}

Pagination.contextType = PaginationContext

export default Pagination